module.exports = __webpack_public_path__ + "media/images/Edit-4e3120a07ea3f0c9fe14e39d9a4952f7.svg";